import createLucideIcon from '../createLucideIcon';

/**
 * @component @name BarChartHorizontal
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyAzdjE4aDE4IiAvPgogIDxwYXRoIGQ9Ik03IDE2aDgiIC8+CiAgPHBhdGggZD0iTTcgMTFoMTIiIC8+CiAgPHBhdGggZD0iTTcgNmgzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bar-chart-horizontal
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BarChartHorizontal = createLucideIcon('BarChartHorizontal', [
  ['path', { d: 'M3 3v18h18', key: '1s2lah' }],
  ['path', { d: 'M7 16h8', key: 'srdodz' }],
  ['path', { d: 'M7 11h12', key: '127s9w' }],
  ['path', { d: 'M7 6h3', key: 'w9rmul' }],
]);

export default BarChartHorizontal;
